import { render } from "./breachPenaltyConfirm.vue?vue&type=template&id=5dac7e3a"
import script from "./breachPenaltyConfirm.vue?vue&type=script&lang=js"
export * from "./breachPenaltyConfirm.vue?vue&type=script&lang=js"

import "./breachPenaltyConfirm.vue?vue&type=style&index=0&id=5dac7e3a&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__